import { apiBase, createClient, tokenStore } from '@ck/sdk';

export const session = tokenStore('ck.partner.session');
export const CLIENT_URL = import.meta.env.VITE_CLIENT_URL ?? 'https://client.ckfundedpro.com';

let onSignedOut: () => void = () => undefined;
export const setSignedOutHandler = (fn: () => void) => { onSignedOut = fn; };

export const api = createClient({
  baseUrl: apiBase(import.meta.env.VITE_API_URL),
  tenant: import.meta.env.VITE_TENANT || undefined,
  token: () => session.get(),
  onUnauthorized: () => { session.set(null); onSignedOut(); },
});
